import { ADMIN_SIDEBAR_OPTIONS, CompanyImage, ComponentStyle, getSession, HamburgerMenu, 
         Image, mobileRedirectToOtherPage, MobileSubSidebar, MobileSidebar, React, setSidebarIcons, SIDEBAR_OPTIONS, SubSidebar, 
         useEffect, useQueryClient, useRouter, useState, useTranslation } from  '@/imports-files/components/mobile-menubar';



         
export function MobileMenubar(props)
{
    
const router                                      =    useRouter();
const {t }  = useTranslation();
const OPTIONS                                     =    router.pathname.startsWith('/admins') ? ADMIN_SIDEBAR_OPTIONS[0] : SIDEBAR_OPTIONS(t)[0];
const [userName, setUserName]                     =    useState('...');
const [userType, setUserType]                     =    useState('');
const [userRole, setUserRole]                     =    useState('');
const queryClient                                 =    useQueryClient();
const mobile_sidebar                              =    new MobileSidebar( props.loadPageInDashboard, queryClient, props.setPageName);
const [sidebarOption, setSubSubSidebarOptions]    =    useState([]);
const [isLoading, setLoading]                     =    useState(true);


useEffect(()=>{
                    (async () => {
                                    const session =  await getSession();
                                    setUserName(session?.name);
                                    setUserType(session?.type);
                                    setUserRole(session?.role);
                                    setLoading(false);
                                 })();
                        
                    document.addEventListener('click', (event) => { mobile_sidebar.handleClickOutside(event) });
              },[userName])


if(isLoading)
{
    return null;
}


return (
       <div className= {`MobileMenuContainer ${ComponentStyle.MobileMenuContainer}`}>
        
            <div>
           {/* ----------------------- Main Sidebar ----------------------- */}
               <div className={ComponentStyle.Menubar}>
                   <div className={ComponentStyle.CompanyContainer}>
                     <Image src={CompanyImage} alt="Company-Logo"  className= {ComponentStyle.CompanyImage}/>
                   </div>

                   <div className={ComponentStyle.SidebarContainer}>
                        <div className = { ComponentStyle.HamburgerSection }>
                            
                            <HamburgerMenu/>

                            <ul className = {`HamburgerMenu__List ${ComponentStyle.HamburgerMenu__List}`}>
                                
                                { Object.keys(OPTIONS).map((key,index) => {

                                    return (
                                                <li id = {key} key = {key}

                                                    className       = { OPTIONS[key]['active'] ?
                                                                        `MobileMenu__Item ${ComponentStyle.MobileMenu__Item} Active`:
                                                                        `MobileMenu__Item ${ComponentStyle.MobileMenu__Item}`}
                                                    sidebar-present = { OPTIONS[key]['sidebar_present'] }>

                                                    <div className      =   {ComponentStyle.MobileMenu__IconContainer}
                                                        onClick         =   {(event) => mobile_sidebar.handleSidebarIconClick(event, OPTIONS[key])}
                                                        data-toggle     =   "tooltip"
                                                        data-placement  =   "top"
                                                        title           =   {key}>

                                                    { setSidebarIcons(key, queryClient) }
                                                    </div>

                                                </li>

                                            )}
                                )}
                                
                                <li>
                                    <Image src='/images/components/sidebar/dummy-user-image.png' 
                                        alt=""  height={40} width={40} 
                                        className={`${ComponentStyle.MobileMenu__AvatarImage}`}/>
                                </li>

                            </ul>                   
                        </div>
                   </div>
               </div>
           {/* ----------------------- Main Sidebar ----------------------- */}
           </div>

                                        
           <div>
           {/* ----------------------- Sub Sidebar ------------------------ */}
                <div className={`MobileSubMenuBar`}>
                        <MobileSubSidebar  setPageName                = {props.setPageName} 
                                           loadPageInDashboard        = {props.loadPageInDashboard} 
                                           setSubSubSidebarOptions    = {setSubSubSidebarOptions} 
                                           userRole                   = {userRole} />
                                           
                        <div className='MobileDropdownSuboption'>
                            {
                                sidebarOption != undefined ? 
                                Object.keys(sidebarOption).map((key,index) => {
                                                                                return( <div    key      =   {index} 
                                                                                                title    =   {key} 
                                                                                                onClick  =   { () => { mobileRedirectToOtherPage(queryClient, sidebarOption[key], props.loadPageInDashboard, props.setPageName) }}>
                                                                                                { sidebarOption[key]['title'] } 
                                                                                        </div> );
                                                                              }):''
                            }
                        </div>
                </div>
           {/* ----------------------- Sub Sidebar ------------------------- */}
           </div>
       </div>
     )
}
